// import React, { useEffect, useMemo, useRef, useState } from "react";
// import "./productForm.css";
// import {
//   FiChevronRight,
//   FiX,
//   FiCheck,
//   FiUploadCloud,
//   FiTag,
//   FiImage,
// } from "react-icons/fi";

// const CATEGORY_OPTIONS = ["Watch", "Headphone", "Speaker", "Gadget"];
// const TAG_OPTIONS = ["Watch", "Gadget", "Fitness", "Smart", "Audio"];
// const STATUS_OPTIONS = ["published", "draft", "out_of_stock"];
// const DISCOUNT_TYPES = [
//   { value: "none", label: "No Discount" },
//   { value: "percentage", label: "Percentage" },
//   { value: "flat", label: "Flat Amount" },
// ];
// const TAX_CLASSES = [
//   { value: "tax_free", label: "Tax Free", rate: 0 },
//   { value: "gst_5", label: "GST 5%", rate: 5 },
//   { value: "gst_18", label: "GST 18%", rate: 18 },
// ];

// const inrFormatter = new Intl.NumberFormat("en-IN", {
//   style: "currency",
//   currency: "INR",
//   maximumFractionDigits: 2,
// });
// const formatINR = (value) => inrFormatter.format(value ?? 0);

// const getTaxRate = (taxClass) => {
//   const found = TAX_CLASSES.find((t) => t.value === taxClass);
//   return found?.rate ?? 0;
// };

// // Base -> apply discount -> add tax (from class) + VAT (%)
// const calcFinalPrice = (form) => {
//   const base = Number(form.basePrice || 0);
//   if (!base || Number.isNaN(base)) return 0;

//   // 1) Discount
//   let priceAfterDiscount = base;
//   if (form.discountType === "percentage") {
//     const pct = Number(form.discountPercent || 0);
//     if (!Number.isNaN(pct) && pct > 0) {
//       priceAfterDiscount = Math.max(0, base - (base * pct) / 100);
//     }
//   } else if (form.discountType === "flat") {
//     const flat = Number(form.discountPercent || 0);
//     if (!Number.isNaN(flat) && flat > 0) {
//       priceAfterDiscount = Math.max(0, base - flat);
//     }
//   }

//   // 2) Tax from class (e.g. GST 5/18)
//   const taxRate = getTaxRate(form.taxClass);
//   const taxAmount = (priceAfterDiscount * taxRate) / 100;

//   // 3) VAT (%)
//   const vatRateRaw = Number(form.vatPercent || 0);
//   const vatRate = !Number.isNaN(vatRateRaw) && vatRateRaw > 0 ? vatRateRaw : 0;
//   const vatAmount = (priceAfterDiscount * vatRate) / 100;

//   const final = priceAfterDiscount + taxAmount + vatAmount;

//   // round to 2 decimals
//   return Math.round(final * 100) / 100;
// };

// const countCompletion = (form) => {
//   const fields = [
//     form.name,
//     form.description,
//     form.basePrice,
//     form.discountType !== "none" ? form.discountPercent : "skip",
//     form.taxClass,
//     form.vatPercent,
//     form.sku,
//     form.barcode,
//     form.quantity,
//     form.weight,
//     form.height,
//     form.length,
//     form.width,
//     form.category,
//     form.tags && form.tags.length ? "ok" : "",
//     form.images && form.images.length ? "ok" : "",
//   ];

//   const relevant = fields.filter((f) => f !== "skip");
//   const total = relevant.length;
//   const completed = relevant.filter(
//     (val) =>
//       val !== null &&
//       val !== undefined &&
//       String(val).toString().trim() !== ""
//   ).length;

//   if (!total) return 0;
//   return Math.round((completed / total) * 100);
// };

// const ProductForm = ({ initialData, onCancel, onSave }) => {
//   const [form, setForm] = useState(initialData);
//   const [errors, setErrors] = useState({});
//   const fileInputRef = useRef(null);

//   useEffect(() => {
//     setForm(initialData);
//     setErrors({});
//   }, [initialData]);

//   const completion = useMemo(() => countCompletion(form), [form]);
//   const effectivePrice = useMemo(() => calcFinalPrice(form), [form]);

//   const handleChange = (field, value) => {
//     setForm((prev) => {
//       const updated = { ...prev, [field]: value };

//       // If user selects "No Discount", clear and disable discount value
//       if (field === "discountType" && value === "none") {
//         updated.discountPercent = "";
//       }

//       return updated;
//     });
//   };

//   const handleNumberChange = (field, raw) => {
//     handleChange(field, raw); // keep as string, validate later
//   };

//   const handleToggleTag = (tag) => {
//     setForm((prev) => {
//       const exists = prev.tags.includes(tag);
//       return {
//         ...prev,
//         tags: exists
//           ? prev.tags.filter((t) => t !== tag)
//           : [...prev.tags, tag],
//       };
//     });
//   };

//   const handleImagesSelect = (e) => {
//     const files = Array.from(e.target.files || []);
//     if (!files.length) return;

//     const mapped = files.map((file) => ({
//       id: `${file.name}-${file.lastModified}-${Math.random()
//         .toString(36)
//         .slice(2, 7)}`,
//       file,
//       url: URL.createObjectURL(file),
//     }));

//     setForm((prev) => ({
//       ...prev,
//       images: [...(prev.images || []), ...mapped],
//     }));
//   };

//   const openFilePicker = () => {
//     fileInputRef.current?.click();
//   };

//   const validate = () => {
//     const newErrors = {};

//     if (!form.name.trim()) newErrors.name = "Product name is required.";
//     if (!form.basePrice || Number.isNaN(Number(form.basePrice))) {
//       newErrors.basePrice = "Enter a valid base price.";
//     }
//     if (!form.sku.trim()) newErrors.sku = "SKU is required.";

//     if (
//       form.quantity &&
//       (Number.isNaN(Number(form.quantity)) || Number(form.quantity) < 0)
//     ) {
//       newErrors.quantity = "Quantity must be a positive number.";
//     }

//     ["weight", "height", "length", "width"].forEach((f) => {
//       const val = form[f];
//       if (val && Number.isNaN(Number(val))) {
//         newErrors[f] = "Enter a valid number.";
//       }
//     });

//     if (form.vatPercent && Number.isNaN(Number(form.vatPercent))) {
//       newErrors.vatPercent = "Enter a valid VAT percentage.";
//     }

//     return newErrors;
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const validation = validate();
//     if (Object.keys(validation).length) {
//       setErrors(validation);
//       return;
//     }
//     setErrors({});
//     onSave(form);
//   };

//   return (
//     <div className="products-page pf-page">
//       {/* HEADER */}
//       <div className="pf-header">
//         <div className="pf-header-top">
//           <div className="pf-header-left">
//             <h1 className="pf-title">Product Details</h1>

//             <div className="pf-breadcrumbs">
//               <span className="breadcrumb-link">Dashboard</span>
//               <FiChevronRight className="breadcrumb-separator-icon" />
//               <span className="breadcrumb-link">Product List</span>
//               <FiChevronRight className="breadcrumb-separator-icon" />
//               <span className="breadcrumb-current">Product Details</span>
//             </div>
//           </div>

//           <div className="pf-header-right">
//             <button
//               type="button"
//               className="btn btn-outline"
//               onClick={onCancel}
//             >
//               <FiX className="btn-icon" />
//               <span>Cancel</span>
//             </button>
//             <button
//               type="submit"
//               form="product-form"
//               className="btn btn-primary"
//             >
//               <FiCheck className="btn-icon" />
//               <span>Save Product</span>
//             </button>
//           </div>
//         </div>
//       </div>

//       {/* FORM BODY */}
//       <form
//         id="product-form"
//         className="pf-form"
//         onSubmit={handleSubmit}
//       >
//         <div className="pf-layout">
//           {/* LEFT COLUMN */}
//           <div className="pf-left">
//             {/* General Information */}
//             <div className="pf-card pf-card-general">
//               <h2 className="pf-card-title">General Information</h2>

//               <div className="pf-field">
//                 <label className="pf-label">Product Name</label>
//                 <input
//                   type="text"
//                   className={`pf-input ${
//                     errors.name ? "pf-input-error" : ""
//                   }`}
//                   placeholder="Enter product name"
//                   value={form.name}
//                   onChange={(e) => handleChange("name", e.target.value)}
//                 />
//                 {errors.name && (
//                   <div className="pf-error-text">{errors.name}</div>
//                 )}
//               </div>

//               <div className="pf-field">
//                 <label className="pf-label">Description</label>
//                 <textarea
//                   rows={5}
//                   className="pf-textarea"
//                   placeholder="Write a short description..."
//                   value={form.description}
//                   onChange={(e) =>
//                     handleChange("description", e.target.value)
//                   }
//                 />
//               </div>
//             </div>

//             {/* Pricing */}
//             <div className="pf-card pf-card-pricing">
//               <h2 className="pf-card-title">Pricing</h2>

//               <div className="pf-field">
//                 <label className="pf-label">Base Price</label>
//                 <div className="pf-input-with-prefix">
//                   <span className="pf-input-prefix">₹</span>
//                   <input
//                     type="number"
//                     min="0"
//                     className={`pf-input no-left-radius ${
//                       errors.basePrice ? "pf-input-error" : ""
//                     }`}
//                     placeholder="0.00"
//                     value={form.basePrice}
//                     onChange={(e) =>
//                       handleNumberChange("basePrice", e.target.value)
//                     }
//                   />
//                 </div>
//                 {errors.basePrice && (
//                   <div className="pf-error-text">{errors.basePrice}</div>
//                 )}
//               </div>

//               <div className="pf-row">
//                 <div className="pf-field pf-col">
//                   <label className="pf-label">Discount Type</label>
//                   <select
//                     className="pf-input"
//                     value={form.discountType}
//                     onChange={(e) =>
//                       handleChange("discountType", e.target.value)
//                     }
//                   >
//                     {DISCOUNT_TYPES.map((opt) => (
//                       <option key={opt.value} value={opt.value}>
//                         {opt.label}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//                 <div className="pf-field pf-col">
//                   <label className="pf-label">
//                     Discount Percentage / Amount
//                   </label>
//                   <input
//                     type="number"
//                     min="0"
//                     className="pf-input"
//                     placeholder="0"
//                     value={form.discountPercent}
//                     onChange={(e) =>
//                       handleNumberChange(
//                         "discountPercent",
//                         e.target.value
//                       )
//                     }
//                     disabled={form.discountType === "none"}
//                   />
//                 </div>
//               </div>

//               <div className="pf-row">
//                 <div className="pf-field pf-col">
//                   <label className="pf-label">Tax Class</label>
//                   <select
//                     className="pf-input"
//                     value={form.taxClass}
//                     onChange={(e) =>
//                       handleChange("taxClass", e.target.value)
//                     }
//                   >
//                     {TAX_CLASSES.map((opt) => (
//                       <option key={opt.value} value={opt.value}>
//                         {opt.label}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//                 <div className="pf-field pf-col">
//                   <label className="pf-label">VAT Amount (%)</label>
//                   <input
//                     type="number"
//                     min="0"
//                     className={`pf-input ${
//                       errors.vatPercent ? "pf-input-error" : ""
//                     }`}
//                     placeholder="0"
//                     value={form.vatPercent}
//                     onChange={(e) =>
//                       handleNumberChange("vatPercent", e.target.value)
//                     }
//                   />
//                   {errors.vatPercent && (
//                     <div className="pf-error-text">
//                       {errors.vatPercent}
//                     </div>
//                   )}
//                 </div>
//               </div>

//               <div className="pf-effective-price">
//                 <span>Final Price:</span>
//                 <strong>{formatINR(effectivePrice)}</strong>
//               </div>
//             </div>

//             {/* Inventory */}
//             <div className="pf-card pf-card-inventory">
//               <h2 className="pf-card-title">Inventory</h2>

//               <div className="pf-row">
//                 <div className="pf-field pf-col">
//                   <label className="pf-label">SKU</label>
//                   <input
//                     type="text"
//                     className={`pf-input ${
//                       errors.sku ? "pf-input-error" : ""
//                     }`}
//                     placeholder="Enter SKU"
//                     value={form.sku}
//                     onChange={(e) => handleChange("sku", e.target.value)}
//                   />
//                   {errors.sku && (
//                     <div className="pf-error-text">{errors.sku}</div>
//                   )}
//                 </div>
//                 <div className="pf-field pf-col">
//                   <label className="pf-label">Barcode</label>
//                   <input
//                     type="text"
//                     className="pf-input"
//                     placeholder="Enter Barcode"
//                     value={form.barcode}
//                     onChange={(e) =>
//                       handleChange("barcode", e.target.value)
//                     }
//                   />
//                 </div>
//                 <div className="pf-field pf-col">
//                   <label className="pf-label">Quantity</label>
//                   <input
//                     type="number"
//                     min="0"
//                     className={`pf-input ${
//                       errors.quantity ? "pf-input-error" : ""
//                     }`}
//                     placeholder="0"
//                     value={form.quantity}
//                     onChange={(e) =>
//                       handleNumberChange("quantity", e.target.value)
//                     }
//                   />
//                   {errors.quantity && (
//                     <div className="pf-error-text">
//                       {errors.quantity}
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>

//             {/* Product Dimensions */}
//             <div className="pf-card pf-card-dimensions">
//               <h2 className="pf-card-title">Product Dimensions</h2>

//               <div className="pf-row pf-row-4">
//                 <div className="pf-field pf-col">
//                   <label className="pf-label">Weight (kg)</label>
//                   <input
//                     type="number"
//                     min="0"
//                     className={`pf-input ${
//                       errors.weight ? "pf-input-error" : ""
//                     }`}
//                     placeholder="0"
//                     value={form.weight}
//                     onChange={(e) =>
//                       handleNumberChange("weight", e.target.value)
//                     }
//                   />
//                   {errors.weight && (
//                     <div className="pf-error-text">
//                       {errors.weight}
//                     </div>
//                   )}
//                 </div>
//                 <div className="pf-field pf-col">
//                   <label className="pf-label">Height (cm)</label>
//                   <input
//                     type="number"
//                     min="0"
//                     className={`pf-input ${
//                       errors.height ? "pf-input-error" : ""
//                     }`}
//                     placeholder="0"
//                     value={form.height}
//                     onChange={(e) =>
//                       handleNumberChange("height", e.target.value)
//                     }
//                   />
//                   {errors.height && (
//                     <div className="pf-error-text">
//                       {errors.height}
//                     </div>
//                   )}
//                 </div>
//                 <div className="pf-field pf-col">
//                   <label className="pf-label">Length (cm)</label>
//                   <input
//                     type="number"
//                     min="0"
//                     className={`pf-input ${
//                       errors.length ? "pf-input-error" : ""
//                     }`}
//                     placeholder="0"
//                     value={form.length}
//                     onChange={(e) =>
//                       handleNumberChange("length", e.target.value)
//                     }
//                   />
//                   {errors.length && (
//                     <div className="pf-error-text">
//                       {errors.length}
//                     </div>
//                   )}
//                 </div>
//                 <div className="pf-field pf-col">
//                   <label className="pf-label">Width (cm)</label>
//                   <input
//                     type="number"
//                     min="0"
//                     className={`pf-input ${
//                       errors.width ? "pf-input-error" : ""
//                     }`}
//                     placeholder="0"
//                     value={form.width}
//                     onChange={(e) =>
//                       handleNumberChange("width", e.target.value)
//                     }
//                   />
//                   {errors.width && (
//                     <div className="pf-error-text">
//                       {errors.width}
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* RIGHT COLUMN */}
//           <div className="pf-right">
//             {/* Category + tags */}
//             <div className="pf-card pf-card-category">
//               <h2 className="pf-card-title">Category</h2>

//               <div className="pf-field">
//                 <label className="pf-label">Product Category</label>
//                 <select
//                   className="pf-input"
//                   value={form.category}
//                   onChange={(e) =>
//                     handleChange("category", e.target.value)
//                   }
//                 >
//                   <option value="">Select category</option>
//                   {CATEGORY_OPTIONS.map((opt) => (
//                     <option key={opt} value={opt}>
//                       {opt}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               <div className="pf-field">
//                 <label className="pf-label">Product Tags</label>
//                 <div className="pf-tags-area">
//                   <div className="pf-tags-selected">
//                     {form.tags?.length ? (
//                       form.tags.map((tag) => (
//                         <button
//                           key={tag}
//                           type="button"
//                           className="pf-tag-pill pf-tag-pill-selected"
//                           onClick={() => handleToggleTag(tag)}
//                         >
//                           <FiTag className="pf-tag-icon" />
//                           <span>{tag}</span>
//                           <span className="pf-tag-remove">×</span>
//                         </button>
//                       ))
//                     ) : (
//                       <span className="pf-tags-placeholder">
//                         No tags selected
//                       </span>
//                     )}
//                   </div>
//                   <div className="pf-tags-options">
//                     {TAG_OPTIONS.map((tag) => (
//                       <button
//                         key={tag}
//                         type="button"
//                         className={`pf-tag-pill ${
//                           form.tags.includes(tag)
//                             ? "pf-tag-pill-selected"
//                             : ""
//                         }`}
//                         onClick={() => handleToggleTag(tag)}
//                       >
//                         <FiTag className="pf-tag-icon" />
//                         {tag}
//                       </button>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Status */}
//             <div className="pf-card pf-card-status">
//               <h2 className="pf-card-title">Status</h2>

//               <div className="pf-field">
//                 <label className="pf-label">Product Status</label>
//                 <select
//                   className="pf-input"
//                   value={form.status}
//                   onChange={(e) =>
//                     handleChange("status", e.target.value)
//                   }
//                 >
//                   {STATUS_OPTIONS.map((opt) => (
//                     <option key={opt} value={opt}>
//                       {opt.replace(/_/g, " ")}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>

//             {/* Product images */}
//             <div className="pf-card pf-card-images">
//               <h2 className="pf-card-title">Products Images</h2>

//               <div className="pf-images-dropzone" onClick={openFilePicker}>
//                 {form.images && form.images.length > 0 ? (
//                   <div className="pf-images-scroll">
//                     {form.images.map((img) => (
//                       <div key={img.id} className="pf-image-thumb">
//                         <img src={img.url} alt="Product" />
//                         <span className="pf-image-check">✓</span>
//                       </div>
//                     ))}
//                   </div>
//                 ) : (
//                   <div className="pf-images-empty">
//                     <FiImage className="pf-images-empty-icon" />
//                     <p className="pf-images-empty-text">
//                       Drag and drop images here, or click to add.
//                     </p>
//                   </div>
//                 )}

//                 <input
//                   type="file"
//                   accept="image/*"
//                   multiple
//                   ref={fileInputRef}
//                   onChange={handleImagesSelect}
//                   style={{ display: "none" }}
//                 />
//               </div>

//               <button
//                 type="button"
//                 className="btn pf-btn-light pf-btn-full"
//                 onClick={openFilePicker}
//               >
//                 <FiUploadCloud className="btn-icon" />
//                 <span>Add Image</span>
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* BOTTOM: PRODUCT COMPLETION */}
//         <div className="pf-bottom-bar">
//           <div className="pf-completion">
//             <span className="pf-completion-label">Product Completion</span>
//             <div className="pf-completion-pill">
//               <div
//                 className="pf-completion-fill"
//                 style={{ width: `${completion}%` }}
//               />
//               <span className="pf-completion-text">
//                 {completion}%
//               </span>
//             </div>
//           </div>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default ProductForm;

import React, { useEffect, useMemo, useRef, useState } from "react";
import "./productForm.css";
import {
  FiChevronRight,
  FiX,
  FiCheck,
  FiUploadCloud,
  FiTag,
  FiImage,
  FiTrash2,
  FiAlertCircle,
} from "react-icons/fi";

const API_BASE = process.env.REACT_APP_EP || "http://localhost:5000";

const DEFAULT_CATEGORIES = [
  { id: "1", name: "testing" },
  { id: "2", name: "Office Supplies" },
];

const TAG_OPTIONS = ["Watch", "Gadget", "Fitness", "Smart", "Audio", "Electronics"];
const STATUS_OPTIONS = ["published", "draft", "out_of_stock"];

// Updated to match API expectations
const DISCOUNT_TYPES = [
  { value: "", label: "No Discount" },
  { value: "percentage", label: "Percentage" },
  { value: "fixed", label: "Fixed Amount" },
];

const TAX_CLASSES = [
  { value: "GST", label: "GST (Default)", rate: 18 },
  { value: "tax_free", label: "Tax Free", rate: 0 },
  { value: "GST_5", label: "GST 5%", rate: 5 },
  { value: "GST_12", label: "GST 12%", rate: 12 },
  { value: "GST_18", label: "GST 18%", rate: 18 },
  { value: "GST_28", label: "GST 28%", rate: 28 },
];

const inrFormatter = new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  maximumFractionDigits: 2,
});
const formatINR = (value) => inrFormatter.format(value ?? 0);

const getTaxRate = (taxClass) => {
  const found = TAX_CLASSES.find((t) => t.value === taxClass);
  return found?.rate ?? 0;
};

const calcFinalPrice = (form) => {
  const base = Number(form?.basePrice || 0);
  if (!base || Number.isNaN(base)) return 0;

  let priceAfterDiscount = base;
  if (form?.discountType === "percentage") {
    const pct = Number(form?.discountPercent || 0);
    if (!Number.isNaN(pct) && pct > 0) {
      priceAfterDiscount = Math.max(0, base - (base * pct) / 100);
    }
  } else if (form?.discountType === "fixed") {
    const fixed = Number(form?.discountPercent || 0);
    if (!Number.isNaN(fixed) && fixed > 0) {
      priceAfterDiscount = Math.max(0, base - fixed);
    }
  }

  const taxRate = getTaxRate(form?.taxClass);
  const taxAmount = (priceAfterDiscount * taxRate) / 100;

  const vatRateRaw = Number(form?.vatPercent || 0);
  const vatRate = !Number.isNaN(vatRateRaw) && vatRateRaw > 0 ? vatRateRaw : 0;
  const vatAmount = (priceAfterDiscount * vatRate) / 100;

  const final = priceAfterDiscount + taxAmount + vatAmount;
  return Math.round(final * 100) / 100;
};

const countCompletion = (form) => {
  if (!form) return 0;

  const fields = [
    form.name,
    form.description,
    form.basePrice,
    form.discountType ? form.discountPercent : "skip",
    form.taxClass,
    form.vatPercent,
    form.sku,
    form.barcode,
    form.quantity,
    form.weight,
    form.height,
    form.length,
    form.width,
    form.category,
    form.tags && form.tags.length ? "ok" : "",
    form.images && form.images.length ? "ok" : "",
  ];

  const relevant = fields.filter((f) => f !== "skip");
  const total = relevant.length;
  const completed = relevant.filter(
    (val) => val !== null && val !== undefined && String(val).trim() !== ""
  ).length;

  if (!total) return 0;
  return Math.round((completed / total) * 100);
};

const getCategoryName = (category) => {
  if (!category) return "";
  if (typeof category === "string") return category;
  if (typeof category === "object") {
    return category.category_name || category.name || "";
  }
  return "";
};

const ProductForm = ({
  initialData,
  onCancel,
  onSave,
  loading: parentLoading,
  error: parentError,
  onClearError,
}) => {
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);
  const [apiError, setApiError] = useState(null);
  const [categories, setCategories] = useState(DEFAULT_CATEGORIES);
  const [loadingCategories, setLoadingCategories] = useState(false);

  const fileInputRef = useRef(null);

  useEffect(() => {
    if (apiError || parentError) {
      setApiError(null);
      if (onClearError) onClearError();
    }
  }, [form]);

  useEffect(() => {
    setForm({
      id: initialData?.id || null,
      name: initialData?.name || "",
      description: initialData?.description || "",
      basePrice: initialData?.basePrice || "",
      discountType: initialData?.discountType || "",
      discountPercent: initialData?.discountPercent || "",
      taxClass: initialData?.taxClass || "GST",
      vatPercent: initialData?.vatPercent || "",
      sku: initialData?.sku || "",
      barcode: initialData?.barcode || "",
      quantity: initialData?.quantity || "",
      weight: initialData?.weight || "",
      height: initialData?.height || "",
      length: initialData?.length || "",
      width: initialData?.width || "",
      category: getCategoryName(initialData?.category),
      categoryId: initialData?.categoryId || null,
      tags: Array.isArray(initialData?.tags) ? initialData.tags : [],
      status: initialData?.status || "draft",
      images: Array.isArray(initialData?.images) ? initialData.images : [],
    });
    setErrors({});
    setApiError(null);
  }, [initialData]);

  useEffect(() => {
    const fetchCategories = async () => {
      setLoadingCategories(true);
      try {
        const response = await fetch(`${API_BASE}/api/categories/list`, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });

        if (response.ok) {
          const data = await response.json();
          const categoryList = data.data || data.categories || data || [];

          if (categoryList.length > 0) {
            const formattedCategories = categoryList.map((c) => {
              if (typeof c === "object" && c !== null) {
                return {
                  id: c.category_id || c.id || c._id || "",
                  name: c.category_name || c.name || "",
                };
              }
              return { id: String(c), name: String(c) };
            });
            setCategories(formattedCategories);
          }
        }
      } catch (err) {
        console.error("Error fetching categories:", err);
      } finally {
        setLoadingCategories(false);
      }
    };

    fetchCategories();
  }, []);

  const completion = useMemo(() => countCompletion(form), [form]);
  const effectivePrice = useMemo(() => calcFinalPrice(form), [form]);

  const handleChange = (field, value) => {
    setForm((prev) => {
      const updated = { ...prev, [field]: value };

      if (field === "discountType" && !value) {
        updated.discountPercent = "";
      }

      if (field === "category") {
        const selectedCat = categories.find((c) => c.name === value);
        updated.categoryId = selectedCat?.id || null;
      }

      return updated;
    });

    if (errors[field]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }
  };

  const handleNumberChange = (field, raw) => {
    handleChange(field, raw);
  };

  const handleToggleTag = (tag) => {
    setForm((prev) => {
      const currentTags = prev.tags || [];
      const exists = currentTags.includes(tag);
      return {
        ...prev,
        tags: exists ? currentTags.filter((t) => t !== tag) : [...currentTags, tag],
      };
    });
  };

  const handleImagesSelect = (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;

    const mapped = files.map((file) => ({
      id: `${file.name}-${file.lastModified}-${Math.random().toString(36).slice(2, 7)}`,
      file,
      url: URL.createObjectURL(file),
    }));

    setForm((prev) => ({
      ...prev,
      images: [...(prev.images || []), ...mapped],
    }));
  };

  const handleRemoveImage = (imageId) => {
    setForm((prev) => ({
      ...prev,
      images: (prev.images || []).filter((img) => img.id !== imageId),
    }));
  };

  const openFilePicker = () => {
    fileInputRef.current?.click();
  };

  const getImageUrl = (imageUrl) => {
    if (!imageUrl) return "";
    if (imageUrl.startsWith("http") || imageUrl.startsWith("blob:")) {
      return imageUrl;
    }
    return `${API_BASE}${imageUrl}`;
  };

  const validate = () => {
    const newErrors = {};

    if (!form.name || !form.name.trim()) {
      newErrors.name = "Product name is required.";
    }

    if (!form.basePrice || Number.isNaN(Number(form.basePrice)) || Number(form.basePrice) <= 0) {
      newErrors.basePrice = "Enter a valid base price greater than 0.";
    }

    if (!form.sku || !form.sku.trim()) {
      newErrors.sku = "SKU is required.";
    }

    if (form.quantity && (Number.isNaN(Number(form.quantity)) || Number(form.quantity) < 0)) {
      newErrors.quantity = "Quantity must be a positive number.";
    }

    ["weight", "height", "length", "width"].forEach((f) => {
      const val = form[f];
      if (val && Number.isNaN(Number(val))) {
        newErrors[f] = "Enter a valid number.";
      }
    });

    if (form.vatPercent && Number.isNaN(Number(form.vatPercent))) {
      newErrors.vatPercent = "Enter a valid VAT percentage.";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setApiError(null);

    const validation = validate();
    if (Object.keys(validation).length) {
      setErrors(validation);
      const firstErrorField = Object.keys(validation)[0];
      const element =
        document.querySelector(`[name="${firstErrorField}"]`) ||
        document.querySelector(`.pf-input-error`);
      element?.scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }

    setErrors({});
    setSaving(true);

    try {
      await onSave(form);
    } catch (err) {
      console.error("Submit error:", err);
      setApiError(err.message || "Failed to save product");
      window.scrollTo({ top: 0, behavior: "smooth" });
    } finally {
      setSaving(false);
    }
  };

  const isLoading = saving || parentLoading;
  const displayError = apiError || parentError;

  return (
    <div className="products-page pf-page">
      {displayError && (
        <div className="pf-error-banner">
          <FiAlertCircle className="pf-error-banner-icon" />
          <div className="pf-error-banner-content">
            <strong>Error:</strong> {displayError}
          </div>
          <button
            className="pf-error-banner-close"
            onClick={() => {
              setApiError(null);
              if (onClearError) onClearError();
            }}
          >
            ×
          </button>
        </div>
      )}

      <div className="pf-header">
        <div className="pf-header-top">
          <div className="pf-header-left">
            <h1 className="pf-title">{form.id ? "Edit Product" : "Add Product"}</h1>
            <div className="pf-breadcrumbs">
              <span className="breadcrumb-link">Dashboard</span>
              <FiChevronRight className="breadcrumb-separator-icon" />
              <button
                type="button"
                className="breadcrumb-link breadcrumb-button"
                onClick={onCancel}
              >
                Product List
              </button>
              <FiChevronRight className="breadcrumb-separator-icon" />
              <span className="breadcrumb-current">
                {form.id ? "Edit Product" : "Add Product"}
              </span>
            </div>
          </div>

          <div className="pf-header-right">
            <button
              type="button"
              className="btn btn-outline"
              onClick={onCancel}
              disabled={isLoading}
            >
              <FiX className="btn-icon" />
              <span>Cancel</span>
            </button>
            <button
              type="submit"
              form="product-form"
              className="btn btn-primary"
              disabled={isLoading}
            >
              <FiCheck className="btn-icon" />
              <span>{isLoading ? "Saving..." : "Save Product"}</span>
            </button>
          </div>
        </div>
      </div>

      <form id="product-form" className="pf-form" onSubmit={handleSubmit}>
        <div className="pf-layout">
          <div className="pf-left">
            <div className="pf-card pf-card-general">
              <h2 className="pf-card-title">General Information</h2>

              <div className="pf-field">
                <label className="pf-label">
                  Product Name <span className="pf-required">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  className={`pf-input ${errors.name ? "pf-input-error" : ""}`}
                  placeholder="Enter product name"
                  value={form.name || ""}
                  onChange={(e) => handleChange("name", e.target.value)}
                />
                {errors.name && <div className="pf-error-text">{errors.name}</div>}
              </div>

              <div className="pf-field">
                <label className="pf-label">Description</label>
                <textarea
                  rows={5}
                  name="description"
                  className="pf-textarea"
                  placeholder="Write a short description..."
                  value={form.description || ""}
                  onChange={(e) => handleChange("description", e.target.value)}
                />
              </div>
            </div>

            <div className="pf-card pf-card-pricing">
              <h2 className="pf-card-title">Pricing</h2>

              <div className="pf-field">
                <label className="pf-label">
                  Base Price <span className="pf-required">*</span>
                </label>
                <div className="pf-input-with-prefix">
                  <span className="pf-input-prefix">₹</span>
                  <input
                    type="number"
                    name="basePrice"
                    min="0"
                    step="0.01"
                    className={`pf-input no-left-radius ${errors.basePrice ? "pf-input-error" : ""}`}
                    placeholder="0.00"
                    value={form.basePrice || ""}
                    onChange={(e) => handleNumberChange("basePrice", e.target.value)}
                  />
                </div>
                {errors.basePrice && <div className="pf-error-text">{errors.basePrice}</div>}
              </div>

              <div className="pf-row">
                <div className="pf-field pf-col">
                  <label className="pf-label">Discount Type</label>
                  <select
                    name="discountType"
                    className="pf-input"
                    value={form.discountType || ""}
                    onChange={(e) => handleChange("discountType", e.target.value)}
                  >
                    {DISCOUNT_TYPES.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="pf-field pf-col">
                  <label className="pf-label">Discount Value</label>
                  <input
                    type="number"
                    name="discountPercent"
                    min="0"
                    className="pf-input"
                    placeholder="0"
                    value={form.discountPercent || ""}
                    onChange={(e) => handleNumberChange("discountPercent", e.target.value)}
                    disabled={!form.discountType}
                  />
                </div>
              </div>

              <div className="pf-row">
                <div className="pf-field pf-col">
                  <label className="pf-label">Tax Class</label>
                  <select
                    name="taxClass"
                    className="pf-input"
                    value={form.taxClass || "GST"}
                    onChange={(e) => handleChange("taxClass", e.target.value)}
                  >
                    {TAX_CLASSES.map((opt) => (
                      <option key={opt.value} value={opt.value}>
                        {opt.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="pf-field pf-col">
                  <label className="pf-label">VAT Percentage (%)</label>
                  <input
                    type="number"
                    name="vatPercent"
                    min="0"
                    className={`pf-input ${errors.vatPercent ? "pf-input-error" : ""}`}
                    placeholder="0"
                    value={form.vatPercent || ""}
                    onChange={(e) => handleNumberChange("vatPercent", e.target.value)}
                  />
                  {errors.vatPercent && <div className="pf-error-text">{errors.vatPercent}</div>}
                </div>
              </div>

              {/* <div className="pf-effective-price">
                <span>Final Price:</span>
                <strong>{formatINR(effectivePrice)}</strong>
              </div> */}
            </div>

            <div className="pf-card pf-card-inventory">
              <h2 className="pf-card-title">Inventory</h2>

              <div className="pf-row">
                <div className="pf-field pf-col">
                  <label className="pf-label">
                    SKU <span className="pf-required">*</span>
                  </label>
                  <input
                    type="text"
                    name="sku"
                    className={`pf-input ${errors.sku ? "pf-input-error" : ""}`}
                    placeholder="Enter SKU"
                    value={form.sku || ""}
                    onChange={(e) => handleChange("sku", e.target.value)}
                    disabled={!!form.id}
                  />
                  {errors.sku && <div className="pf-error-text">{errors.sku}</div>}
                </div>
                <div className="pf-field pf-col">
                  <label className="pf-label">Barcode</label>
                  <input
                    type="text"
                    name="barcode"
                    className="pf-input"
                    placeholder="Enter Barcode"
                    value={form.barcode || ""}
                    onChange={(e) => handleChange("barcode", e.target.value)}
                  />
                </div>
                <div className="pf-field pf-col">
                  <label className="pf-label">Quantity</label>
                  <input
                    type="number"
                    name="quantity"
                    min="0"
                    className={`pf-input ${errors.quantity ? "pf-input-error" : ""}`}
                    placeholder="0"
                    value={form.quantity || ""}
                    onChange={(e) => handleNumberChange("quantity", e.target.value)}
                  />
                  {errors.quantity && <div className="pf-error-text">{errors.quantity}</div>}
                </div>
              </div>
            </div>

            <div className="pf-card pf-card-dimensions">
              <h2 className="pf-card-title">Product Dimensions</h2>

              <div className="pf-row pf-row-4">
                <div className="pf-field pf-col">
                  <label className="pf-label">Weight (kg)</label>
                  <input
                    type="number"
                    name="weight"
                    min="0"
                    step="0.01"
                    className={`pf-input ${errors.weight ? "pf-input-error" : ""}`}
                    placeholder="0"
                    value={form.weight || ""}
                    onChange={(e) => handleNumberChange("weight", e.target.value)}
                  />
                </div>
                <div className="pf-field pf-col">
                  <label className="pf-label">Height (cm)</label>
                  <input
                    type="number"
                    name="height"
                    min="0"
                    step="0.01"
                    className={`pf-input ${errors.height ? "pf-input-error" : ""}`}
                    placeholder="0"
                    value={form.height || ""}
                    onChange={(e) => handleNumberChange("height", e.target.value)}
                  />
                </div>
                <div className="pf-field pf-col">
                  <label className="pf-label">Length (cm)</label>
                  <input
                    type="number"
                    name="length"
                    min="0"
                    step="0.01"
                    className={`pf-input ${errors.length ? "pf-input-error" : ""}`}
                    placeholder="0"
                    value={form.length || ""}
                    onChange={(e) => handleNumberChange("length", e.target.value)}
                  />
                </div>
                <div className="pf-field pf-col">
                  <label className="pf-label">Width (cm)</label>
                  <input
                    type="number"
                    name="width"
                    min="0"
                    step="0.01"
                    className={`pf-input ${errors.width ? "pf-input-error" : ""}`}
                    placeholder="0"
                    value={form.width || ""}
                    onChange={(e) => handleNumberChange("width", e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="pf-right">
            <div className="pf-card pf-card-category">
              <h2 className="pf-card-title">Category</h2>

              <div className="pf-field">
                <label className="pf-label">Product Category</label>
                <select
                  name="category"
                  className="pf-input"
                  value={form.category || ""}
                  onChange={(e) => handleChange("category", e.target.value)}
                  disabled={loadingCategories}
                >
                  <option value="">
                    {loadingCategories ? "Loading..." : "Select category"}
                  </option>
                  {categories.map((cat) => (
                    <option key={cat.id} value={cat.name}>
                      {cat.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* <div className="pf-field">
                <label className="pf-label">Product Tags</label>
                <div className="pf-tags-area">
                  <div className="pf-tags-selected">
                    {form.tags?.length ? (
                      form.tags.map((tag) => (
                        <button
                          key={tag}
                          type="button"
                          className="pf-tag-pill pf-tag-pill-selected"
                          onClick={() => handleToggleTag(tag)}
                        >
                          <FiTag className="pf-tag-icon" />
                          <span>{tag}</span>
                          <span className="pf-tag-remove">×</span>
                        </button>
                      ))
                    ) : (
                      <span className="pf-tags-placeholder">No tags selected</span>
                    )}
                  </div>
                  <div className="pf-tags-options">
                    {TAG_OPTIONS.map((tag) => (
                      <button
                        key={tag}
                        type="button"
                        className={`pf-tag-pill ${form.tags?.includes(tag) ? "pf-tag-pill-selected" : ""}`}
                        onClick={() => handleToggleTag(tag)}
                      >
                        <FiTag className="pf-tag-icon" />
                        {tag}
                      </button>
                    ))}
                  </div>
                </div>
              </div> */}
            </div>

            <div className="pf-card pf-card-status">
              <h2 className="pf-card-title">Status</h2>

              <div className="pf-field">
                <label className="pf-label">Product Status</label>
                <select
                  name="status"
                  className="pf-input"
                  value={form.status || "draft"}
                  onChange={(e) => handleChange("status", e.target.value)}
                >
                  {STATUS_OPTIONS.map((opt) => (
                    <option key={opt} value={opt}>
                      {opt.replace(/_/g, " ")}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="pf-card pf-card-images">
              <h2 className="pf-card-title">Product Images</h2>

              <div className="pf-images-dropzone" onClick={openFilePicker}>
                {form.images && form.images.length > 0 ? (
                  <div className="pf-images-scroll">
                    {form.images.map((img) => (
                      <div key={img.id} className="pf-image-thumb">
                        <img src={getImageUrl(img.url)} alt="Product" />
                        <span className="pf-image-check">✓</span>
                        <button
                          type="button"
                          className="pf-image-remove"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleRemoveImage(img.id);
                          }}
                        >
                          <FiTrash2 size={12} />
                        </button>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="pf-images-empty">
                    <FiImage className="pf-images-empty-icon" />
                    <p className="pf-images-empty-text">
                      Drag and drop images here, or click to add.
                    </p>
                  </div>
                )}

                <input
                  type="file"
                  accept="image/*"
                  multiple
                  ref={fileInputRef}
                  onChange={handleImagesSelect}
                  style={{ display: "none" }}
                />
              </div>

              <button
                type="button"
                className="btn pf-btn-light pf-btn-full"
                onClick={openFilePicker}
              >
                <FiUploadCloud className="btn-icon" />
                <span>Add Image</span>
              </button>
            </div>
          </div>
        </div>

        <div className="pf-bottom-bar">
          <div className="pf-completion">
            <span className="pf-completion-label">Product Completion</span>
            <div className="pf-completion-pill">
              <div className="pf-completion-fill" style={{ width: `${completion}%` }} />
              <span className="pf-completion-text">{completion}%</span>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default ProductForm;